/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DoctorsAndAssistants/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DoctorsAndAssistants({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/MonthlyCalendar/Content/CalendarDay/SlotsPopover/DoctorsAndAssistants"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let constantData = 'providers'
let calendarDayProvidersAndAssistantsValueData = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'providers_and_assistants',
})
let aggregateData = fromHelpers.joinWithComma(constantData, calendarDayProvidersAndAssistantsValueData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let constantData1 = 'assistants'
let calendarDayProvidersAndAssistantsValueData1 = fromData.useDataValue({ viewPath,
context: 'calendar_day',
path: 'providers_and_assistants',
})
let aggregateData1 = fromHelpers.joinWithComma(constantData1, calendarDayProvidersAndAssistantsValueData1)
  return (<React.Fragment
>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
 marginTop={dtSpaceXxs}
 marginBottom={dtSpaceXxs}
/>
<div
  data-testid="DoctorsAndAssistants.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-1QlGSS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pl-2-1QlGSS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pr-3-1QlGSS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="DoctorsAndAssistants.Vertical:1"
  data-view-path={viewPath}
 style={{'--g-4-1QlGSS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Providers"
 color={dtColorsNeutral400}
 weight="semibold"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color="#4F566B"
 data="'providers'"
 data="calendar_day.providers_and_assistants"
 aggregate="helpers.js joinWithComma"
 text={aggregateData}
/>
</div>
<div
  data-testid="DoctorsAndAssistants.Vertical:2"
  data-view-path={viewPath}
 style={{'--g-4-1QlGSS': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--mt-1-1QlGSS': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Assistants"
 color={dtColorsNeutral400}
 weight="semibold"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color="#4F566B"
 data="'assistants'"
 data="calendar_day.providers_and_assistants"
 aggregate="helpers.js joinWithComma"
 text={aggregateData1}
/>
</div>
</div>
{children}
</React.Fragment>)
}